<article id="results-page">
  <swoosh [text]="swooshText" [external]="swooshExternal"></swoosh>
  <div *ngIf="!isShowingEmptyState()" class="container results-intro-copy" [innerHtml]="introduction | safeHtml"></div>
  <profile-header></profile-header>

  <div *ngIf="!isShowingEmptyState()">
    <div class="desktop d-none d-md-block" [hidden]="isMobileLayout">
      <div class="navigation">
        <nav ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs container nav-pills nav-justified">
          <ng-container ngbNavItem="characteristics">
            <a ngbNavLink>Characteristics</a>
            <ng-template ngbNavContent>
              <app-results-characteristics *ngIf="!isShowingEmptyState(); else desktopLockedDownView"></app-results-characteristics>
            </ng-template>
          </ng-container>
          <ng-container ngbNavItem="strengths">
            <a ngbNavLink>Strengths</a>
            <ng-template ngbNavContent>
              <app-results-strengths *ngIf="!isShowingEmptyState(); else desktopLockedDownView"></app-results-strengths>
            </ng-template>
          </ng-container>
          <ng-container ngbNavItem="blind-spots">
            <a ngbNavLink>Challenges</a>
            <ng-template ngbNavContent>
              <app-results-blind-spots *ngIf="!isShowingEmptyState(); else desktopLockedDownView"></app-results-blind-spots>
            </ng-template>
          </ng-container>
        </nav>
      </div>
      <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
    <div class="mobile d-block d-md-none" [hidden]="!isMobileLayout">
      <div class="divider header"></div>

      <div class="accordion card-container" id="accordionEx">
        <div class="card gray-bottom">
          <div class="card-header pointer collapsed" data-bs-toggle="collapse" data-bs-target="#card1">
            Characteristics
            <span class="readmore right">&#xFF0D;</span>
            <span class="readless right">&#xFF0B;</span>
          </div>
          <div id="card1" class="card-body collapse" data-parent="#accordionEx">
            <div class="card-body">
              <app-results-characteristics></app-results-characteristics>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="card">
          <div class="card-header pointer collapsed" data-bs-toggle="collapse" data-bs-target="#card2">
            Strengths
            <span class="readmore right">&#xFF0D;</span>
            <span class="readless right">&#xFF0B;</span>
          </div>
          <div id="card2" class="card-body collapse" data-parent="#accordionEx">
            <div class="card-body">
              <app-results-strengths></app-results-strengths>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="card">
          <div class="card-header pointer collapsed" data-bs-toggle="collapse" data-bs-target="#card3">
            Challenges
            <span class="readmore right">&#xFF0D;</span>
            <span class="readless right">&#xFF0B;</span>
          </div>
          <div id="card3" class="card-body collapse" data-parent="#accordionEx">
            <div class="card-body">
              <app-results-blind-spots></app-results-blind-spots>
            </div>
          </div>
        </div>
        <div class="divider"></div>
      </div>
    </div>
  </div>
  <ng-template #desktopLockedDownView>
    <div class="container locked-down-void"></div>
  </ng-template>
</article>
